// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__3T7Tx","title":"styles_title__3_0-B"};